export const getEntityIdByIri = (iri) =>{
const iriParts = iri.split('/');
const id = iriParts[iriParts.length - 1];

return id
}